'use client';

import React, { createContext, useContext } from 'react';

export type CompositionDensity = 'productive' | 'comfort';
const DensityContext = createContext<CompositionDensity>('productive');

/** The template owns density; leaf components inherit it. */
export function CompositionDensityProvider({
  density,
  children,
}: {
  density: CompositionDensity;
  children: React.ReactNode;
}) {
  return <DensityContext.Provider value={density}>{children}</DensityContext.Provider>;
}

export function useCompositionDensity(override?: CompositionDensity): CompositionDensity {
  const density = useContext(DensityContext);
  return override ?? density;
}
